import { render, staticRenderFns } from "./DetailsClient.vue?vue&type=template&id=406915fb&"
import script from "./DetailsClient.vue?vue&type=script&lang=js&"
export * from "./DetailsClient.vue?vue&type=script&lang=js&"
import style0 from "./DetailsClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports